import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import GoogleConnect from './google-connect';
import AppNewDesign from './new-auth';
import { initAuthDesignDDContext } from './login/helpers';

const AppRoutes = () => {
  useEffect(() => {
    initAuthDesignDDContext();
  }, []);

  return (
    <Switch>
      <Route exact path="/google-connect" component={GoogleConnect} />
      <Route path="/" component={AppNewDesign} />
    </Switch>
  );
};

export default AppRoutes;
